// @ts-nocheck
import { cn } from '@/lib/utils';
import { ReactNode, MouseEventHandler } from 'react';

type MobileStatCardProps = {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  tone?: 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'neutral';
  hint?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
};

// Todos no dourado da marca; só "danger" ganha um rosado discreto
const BRAND = 'bg-[#faf7f2] text-[#a88a5c] ring-1 ring-[#c4ab83]/25';
const TONE_CLASSES: Record<NonNullable<MobileStatCardProps['tone']>, string> = {
  primary: BRAND,
  success: BRAND,
  warning: BRAND,
  info: BRAND,
  neutral: BRAND,
  danger: 'bg-rose-50 text-rose-600 ring-1 ring-rose-200',
};

export const MobileStatCard = ({
  label,
  value,
  icon,
  tone = 'primary',
  hint,
  onClick,
  className,
}: MobileStatCardProps) => {
  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      className={cn(
        'relative overflow-hidden rounded-2xl p-3.5 bg-white border border-[#c4ab83]/20 shadow-[0_10px_28px_-22px_rgba(15,23,42,0.35)] flex flex-col gap-2 text-left active:scale-[0.98] transition-transform',
        onClick && 'cursor-pointer',
        className,
      )}
    >
      <div aria-hidden className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-[#c4ab83] to-transparent" />
      <div className="flex items-start justify-between gap-2">
        <span className="text-[10.5px] font-medium uppercase tracking-[0.12em] leading-snug text-slate-500">
          {label}
        </span>
        {icon && (
          <div
            className={cn(
              'h-8 w-8 shrink-0 rounded-xl flex items-center justify-center',
              TONE_CLASSES[tone],
            )}
          >
            {icon}
          </div>
        )}
      </div>
      <div className="text-[22px] font-semibold leading-tight tracking-tight tabular-nums text-slate-900">
        {value}
      </div>
      {hint && (
        <div className="text-[11px] text-slate-500 leading-tight">
          {hint}
        </div>
      )}
    </div>
  );
};
